import { formatIntegration } from '../../../../../utils/formatIntegration';

export const filterIntegrations = (integrations: readonly string[], query: string): readonly string[] => {
  const needle = query.trim().toLowerCase();

  if (needle === '') {
    return integrations;
  }

  return integrations.filter((integration) =>
    [formatIntegration(integration), integration].some((term) => term.toLowerCase().includes(needle))
  );
};
